export const translations = {
  en: {
    header: { signup: 'Sign Up', login: 'Login' },
    hero: {
      badge: '🎉 100% FREE tarif included',
      title: 'Your AI Scout for <span class="grad">Hidden Opportunities</span> on Social Media.',
      sub: 'Flautreach monitors Reddit, LinkedIn, and Facebook 24/7. Get instant email alerts whenever someone is looking for your services, mentioning your competitors, or discussing your niche.',
      ctaPrimary: 'Start Discovering Leads for Free',
      ctaSecondary: 'Sign up with Email',
      mock: [
        { platform: 'Reddit', icon: 'r/', color: '#ff4500', title: 'New lead · Reddit', body: 'Looking for a developer to build e-commerce site, budget $5k', tag: 'Web Development', time: '2m ago' },
        { platform: 'LinkedIn', icon: 'in', color: '#0a66c2', title: 'New lead · LinkedIn', body: 'Anyone recommend a reliable marketing agency for B2B SaaS?', tag: 'Marketing', time: '6m ago' },
        { platform: 'Facebook', icon: 'f', color: '#1877f2', title: 'Competitor mention · Facebook', body: 'So frustrated with [Competitor] — looking for alternatives', tag: 'Competitor Intel', time: '14m ago' },
      ]
    },
    why: {
      tag: 'Why Flautreach?',
      title: 'Stop Pitching to Cold Leads. Start Talking to People Who Need You Now.',
      sub: 'Most services just "track keywords." Flautreach understands intent. We don\'t just find words — we find opportunities.',
      cards: [
        { emoji: '💰', title: 'Find High-Ticket Clients', text: 'Be the first to reply when someone asks for a recommendation or a service provider. Speed is everything — the first responder wins the deal.' },
        { emoji: '🚀', title: 'Grow via Smart Commenting', text: 'Get notified about viral industry threads and build your authority by being the first expert on the scene. Turn visibility into credibility.' },
        { emoji: '🕵️', title: 'Spy on Competitors', text: 'Hear what people hate about your rivals and offer them a better solution immediately. Turn their weaknesses into your wins.' },
        { emoji: '🔬', title: 'Niche Research', text: 'Discover where your audience hangs out and what problems they are actually trying to solve. Real data, not assumptions.' },
      ]
    },
    how: {
      tag: 'Our Process',
      title: 'Three steps to your next deal.',
      sub: 'No SEO or keyword skills required.',
      steps: [
        { num: '01', title: 'Select Your Platforms', text: 'Choose where your audience lives — Reddit, Facebook Groups, or LinkedIn. Mix and match for maximum coverage across your niche.' },
        { num: '02', title: 'Describe Your Goal', text: 'In plain English, tell our AI what you\'re looking for — "I want to find people looking for a web designer" or "Alert me when people complain about Shopify."' },
        { num: '03', title: 'Get Email Alerts', text: 'Our neural network scans thousands of posts and sends a direct link to your inbox the moment a match is found. React before anyone else.' },
      ]
    },
    ai: {
      tag: 'Powered by AI',
      title: 'Why it works better than everything else.',
      cards: [
        { icon: '🧠', title: 'Context over Keywords', text: 'Our AI knows the difference between someone who is a real lead and someone who isn\'t. It reads meaning, not just words — so you only hear about people who actually need you.', example: '<span class="lead-yes">✓ Lead:</span> "I hate my website, I need someone to redesign it"<br><br><span class="lead-no">✗ Not a lead:</span> "I\'m learning how to build a website"' },
        { icon: '🎯', title: 'Zero Noise', text: 'We filter out the spam, bots, and low-quality posts so you only spend time on real opportunities. Every alert you get is worth reading.', example: 'Our AI processes <strong>thousands of posts per hour</strong> and surfaces only the ones that match your exact intent — not just a keyword match.' },
      ]
    },
    pricing: {
  title: 'Start for Free. Pay as you scale.',
  desc: 'No subscriptions, no contracts. Start with a free trial, then pay only for what you use.',
  planName: 'Free Trial',
  price: '$0',
  period: '14 days',
  badge: '🎉 No credit card required',
  features: [
    'Full access to Instagram, Facebook & LinkedIn',
    'Find first clients for free',
   
  ],
  note: 'After trial, pay as you go. Scale at your own pace.',
  cta: 'Start Free Trial',
},
    faq: {
      tag: 'FAQ',
      title: 'Quick answers.',
      items: [
        { q: 'Is it just for sales?', a: 'No. Flautreach is for anyone who wants to be "in the room" when their topic is discussed — whether that\'s for PR, networking, recruiting, competitor research, or niche discovery. If it matters to you, we\'ll find it.' },
        { q: 'Do I need to be an AI expert?', a: 'Not at all. If you can describe your business to a friend, you can use Flautreach. Just tell us what you\'re looking for in plain English and we\'ll handle the rest.' },
        { q: 'What platforms does Flautreach monitor?', a: 'We monitor Reddit (thousands of subreddits), Facebook Groups, and LinkedIn in real-time. You choose which platforms matter most for your business and we focus there.' },
        { q: 'How is this different from Google Alerts or keyword tools?', a: 'Most tools just match keywords — they\'ll send you every post containing "web design" whether it\'s a lead or a tutorial. Flautreach understands intent. We only surface posts where someone genuinely needs your help, not just talks about your topic.' },
        { q: 'Is the free tier really free forever?', a: 'Yes. The free tier includes 20 AI-powered notifications per month with no time limit and no credit card required. When you need more, additional notifications are just $0.05 each — pay only for what you use.' },
      ]
    },
    cta: {
      title: 'Find your next client before your competitors do.',
      sub: 'Join freelancers and agencies already using Flautreach to win more work every week.',
      btn: 'Start Discovering Leads for Free',
    },
    footer: {
      email: 'hello@flautreach.com',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      getStarted: 'Get Started',
      copy: '© 2025 Flautreach. All rights reserved. Never miss an opportunity.',
    }
  },
  pl: {
    header: { signup: 'Rejestracja', login: 'Logowanie' },
    hero: {
      badge: '🎉 100% DARMOWA taryfa w cenie',
      title: 'Twój AI-Skaut Ukrytych Okazji w Mediach Społecznościowych.',
      sub: 'Flautreach monitoruje Reddit, LinkedIn i Facebook 24/7. Otrzymuj natychmiastowe powiadomienia e-mail, gdy ktoś szuka Twoich usług, wspomina o Twojej konkurencji lub dyskutuje o Twojej niszy.',
      ctaPrimary: 'Zacznij Pozyskiwać Leady za Darmo',
      ctaSecondary: 'Zarejestruj się przez E-mail',
      mock: [
        { platform: 'Reddit', icon: 'r/', color: '#ff4500', title: 'Nowy lead · Reddit', body: 'Szukam developera do zbudowania strony e-commerce, budżet 5 tys. $', tag: 'Web Development', time: '2 min temu' },
        { platform: 'LinkedIn', icon: 'in', color: '#0a66c2', title: 'Nowy lead · LinkedIn', body: 'Czy ktoś poleca sprawdzoną agencję marketingową dla B2B SaaS?', tag: 'Marketing', time: '6 min temu' },
        { platform: 'Facebook', icon: 'f', color: '#1877f2', title: 'Wzmianka o konkurencji · Facebook', body: 'Mam dość [Konkurencja] — szukam alternatyw', tag: 'Dane o Konkurencji', time: '14 min temu' },
      ]
    },
    why: {
      tag: 'Dlaczego Flautreach?',
      title: 'Przestań Pisać do Zimnych Leadów. Zacznij Rozmawiać z Ludźmi, Którzy Potrzebują Cię Teraz.',
      sub: 'Większość narzędzi tylko „śledzi słowa kluczowe". Flautreach rozumie intencje. Nie znajdujemy tylko słów — znajdujemy okazje.',
      cards: [
        { emoji: '💰', title: 'Znajdź Wysokopłatnych Klientów', text: 'Bądź pierwszy, gdy ktoś prosi o rekomendację lub usługodawcę. Szybkość to wszystko — pierwsza odpowiedź wygrywa zlecenie.' },
        { emoji: '🚀', title: 'Rośnij dzięki Inteligentnemu Komentowaniu', text: 'Otrzymuj powiadomienia o popularnych wątkach branżowych i buduj swój autorytet jako pierwszy ekspert na miejscu. Zamień widoczność w wiarygodność.' },
        { emoji: '🕵️', title: 'Szpieguj Konkurencję', text: 'Słuchaj, czego ludzie nie lubią u Twoich rywali i natychmiast zaoferuj im lepsze rozwiązanie. Zamień ich słabości w swoje wygrane.' },
        { emoji: '🔬', title: 'Badanie Niszy', text: 'Odkryj, gdzie przebywa Twoja publiczność i jakie problemy naprawdę próbuje rozwiązać. Prawdziwe dane, nie przypuszczenia.' },
      ]
    },
    how: {
      tag: 'Nasz Proces',
      title: 'Trzy kroki do Twojego następnego zlecenia.',
      sub: 'Bez umiejętności SEO ani słów kluczowych.',
      steps: [
        { num: '01', title: 'Wybierz Swoje Platformy', text: 'Wybierz, gdzie mieszka Twoja publiczność — Reddit, Grupy na Facebooku lub LinkedIn. Mieszaj i dopasowuj dla maksymalnego zasięgu w swojej niszy.' },
        { num: '02', title: 'Opisz Swój Cel', text: 'Zwykłym językiem powiedz naszej AI, czego szukasz — „Chcę znaleźć osoby szukające projektanta stron" lub „Powiadom mnie, gdy ludzie narzekają na Shopify".' },
        { num: '03', title: 'Otrzymuj Alerty E-mail', text: 'Nasza sieć neuronowa skanuje tysiące postów i wysyła bezpośredni link na Twoją skrzynkę w momencie znalezienia dopasowania. Reaguj przed wszystkimi.' },
      ]
    },
    ai: {
      tag: 'Napędzane przez AI',
      title: 'Dlaczego działa lepiej niż wszystko inne.',
      cards: [
        { icon: '🧠', title: 'Kontekst ponad Słowa Kluczowe', text: 'Nasza AI zna różnicę między prawdziwym leadem a kimś, kto nim nie jest. Czyta znaczenie, nie tylko słowa — więc słyszysz tylko o ludziach, którzy naprawdę Cię potrzebują.', example: '<span class="lead-yes">✓ Lead:</span> „Nienawidzę swojej strony, potrzebuję kogoś do przeprojektowania"<br><br><span class="lead-no">✗ Nie lead:</span> „Uczę się, jak zbudować stronę internetową"' },
        { icon: '🎯', title: 'Zero Szumu', text: 'Filtrujemy spam, boty i posty niskiej jakości, abyś spędzał czas tylko na prawdziwych okazjach. Każdy alert, który otrzymujesz, jest wart przeczytania.', example: 'Nasza AI przetwarza <strong>tysiące postów na godzinę</strong> i wyławia tylko te, które pasują do Twojej dokładnej intencji — nie tylko dopasowanie słów kluczowych.' },
      ]
    },
    "pricing": {
      "title": "Zacznij za darmo. Płać w miarę rozwoju.",
      "desc": "Bez subskrypcji, bez umów. Rozpocznij od darmowego okresu próbnego, a potem płać tylko za to, czego używasz.",
      "planName": "Darmowy okres próbny",
      "price": "0 zł",
      "period": "14 dni",
      "badge": "🎉 Karta kredytowa nie jest wymagana",
      "features": [
        "Pełny dostęp do Instagrama, Facebooka i LinkedIn",
        "Znajdź pierwszych klientów za darmo"
      ],
      "note": "Po okresie próbnym płać za wykorzystane zasoby. Rozwijaj się we własnym tempie.",
      "cta": "Rozpocznij darmowy okres próbny"
    },
    faq: {
      tag: 'FAQ',
      title: 'Szybkie odpowiedzi.',
      items: [
        { q: 'Czy to tylko do sprzedaży?', a: 'Nie. Flautreach jest dla każdego, kto chce być „w pokoju", gdy dyskutowany jest jego temat — czy to do PR, networkingu, rekrutacji, badania konkurencji czy odkrywania niszy. Jeśli to dla Ciebie ważne, znajdziemy to.' },
        { q: 'Czy muszę być ekspertem AI?', a: 'Absolutnie nie. Jeśli potrafisz opisać swój biznes znajomemu, możesz korzystać z Flautreach. Po prostu powiedz nam, czego szukasz zwykłym językiem, a my zajmiemy się resztą.' },
        { q: 'Jakie platformy monitoruje Flautreach?', a: 'Monitorujemy Reddit (tysiące subredditów), Grupy na Facebooku i LinkedIn w czasie rzeczywistym. Ty wybierasz, które platformy są najważniejsze dla Twojego biznesu, a my się na nich skupiamy.' },
        { q: 'Czym to się różni od Google Alerts lub narzędzi słów kluczowych?', a: 'Większość narzędzi tylko dopasowuje słowa kluczowe — wyślą Ci każdy post zawierający „projektowanie stron", niezależnie czy to lead, czy poradnik. Flautreach rozumie intencje. Wyławiamy tylko posty, w których ktoś naprawdę potrzebuje Twojej pomocy, a nie tylko mówi o Twoim temacie.' },
        { q: 'Czy darmowy pakiet jest naprawdę darmowy na zawsze?', a: 'Tak. Darmowy pakiet obejmuje 20 powiadomień AI miesięcznie bez limitu czasu i bez karty kredytowej. Gdy potrzebujesz więcej, dodatkowe powiadomienia kosztują tylko 0,05 $ każde — płać tylko za to, czego używasz.' },
      ]
    },
    cta: {
      title: 'Znajdź swojego następnego klienta, zanim zrobi to konkurencja.',
      sub: 'Dołącz do freelancerów i agencji już korzystających z Flautreach, aby zdobywać więcej zleceń co tydzień.',
      btn: 'Zacznij Pozyskiwać Leady za Darmo',
    },
    footer: {
      email: 'hello@flautreach.com',
      terms: 'Regulamin',
      privacy: 'Polityka Prywatności',
      getStarted: 'Zacznij',
      copy: '© 2025 Flautreach. Wszelkie prawa zastrzeżone. Nigdy nie przegap okazji.',
    }
  }
};